
/* Theme Code */

// (async() => {
//     const { Core } = await importModule('Core');
//     customElements.define('product-variant-selector', class extends Core {
        
//         render() {
//             this.addEventListener('change', this._onVariantChange.bind(this));
//         }
        
//         _onVariantChange(e) {            
//             this.publish('variant:change', {
//                 optionValueId: e.target.dataset.optionValueId, 
//                 optionIndex: e.target.dataset.optionIndex,
//                 variantId: e.target.dataset.variantId,
//                 imagePosition: e.target.dataset.imagePosition
//             });
//         }
//     });
// })()


/* Custom Code */
(async () => {
    const { Core } = await importModule('Core');

    customElements.define('product-variant-selector', class extends Core {

        render() {
            this.addEventListener('change', this._onVariantChange.bind(this));
        }

        _onVariantChange(e) {
            setTimeout(() => {
                const productGalleryElement = document.querySelector('product-gallery');
                // console.log("product-gallery element:", productGalleryElement);

                if (productGalleryElement) {
                    const imagePositionState = productGalleryElement.getAttribute('data-image-position');
                    const payload = {
                        optionValueId: e.target.dataset.optionValueId, 
                        optionIndex: e.target.dataset.optionIndex,
                        variantId: e.target.dataset.variantId
                    };

                    // Include imagePosition only if the data-image-position is 'false'
                    if (imagePositionState === 'false') {
                        payload.imagePosition = e.target.dataset.imagePosition;
                    }
                    this.publish('variant:change', payload);
                }
            }, 500); 
        }
    });
})();
